import React, { Component } from "react";
import { connect } from "react-redux";
import { getUserInfo, GET_PROD_SUBSCRIPTION, GET_SOCIAL_ACCOUNT_DATA, GET_UGC_ADDON_SUBSCRIPTION_DATA, GET_WIDGET_ADDON_SUBSCRIPTION_DATA, SOCIAL_ACCOUNT_ADD_ACCOUNT_DATA } from "../../../../actions/accountsActions";
import AccountInfo from "./Component/AccountInfo";
import AccountTabs from "./Component/AccountTabs";
import ProductSubscription from "./Component/ProductSubscription";
import SocialAccount from "./Component/SocialAccount";
import AccountSkeleton from "./Skeleton/AccountSkeleton";
import ProductSubscriptionsSkeleton from "./Skeleton/ProductSubscriptionsSkeleton";
import SocialAccountSkeleton from "./Skeleton/SocialAccountSkeleton";
import AccountHeading from "./Component/AccountHeading";
import Cancellation from "../Cancellation/Index";
import { PRODUCT_CANCELANCELLATION_STATUS } from "../../../../reducers/keys";
import MfaAuthenticator from "./Component/MfaAuthenticator";
class Transaction extends Component {

  state = { pageStatus: false }

  componentDidMount() {
    const { authorized, getWidgetAddonData, GET_SOCIAL_ACCOUNT_DATA, getAddAccountList, getProductInfo, getUgcAddonData, getUserInfo } = this.props;
    const { userData } = authorized;
    const userId = userData && Object.keys(userData).length > 0 ? userData.user && Object.keys(userData.user).length > 0 ? userData.user.userhashId : 0 : 0;

    const getInfo = async () => {
      await getUserInfo();
      await getProductInfo();
      await GET_SOCIAL_ACCOUNT_DATA(userId);
      // await getWidgetAddonData();
      // await getUgcAddonData();
      await getAddAccountList();
    };
    getInfo();
  }

  handleParentStatus = (status) => {
    const navs = document.querySelectorAll('#accounts-nav .nav-item .nav-link');
    const tabs = document.querySelectorAll('#accounts-tab .tab-pane');

    navs.forEach((nav)=>{
      if(nav.href.includes('productSubscriptions')){
        nav.classList.add('active');
      }else{
        nav.classList.remove('active');
      }
    });

    tabs.forEach((tab)=>{
      if(tab.id == 'productSubscriptions'){
        tab.classList.add('show', 'active');
      }else{
        tab.classList.remove('show', 'active');
      }
    });
    this.props.productCancellationStatus(status)
  }

  render() {
    const { userInfo, productInfo, authorized, socialAccountsData, widgetAddon, ugcAddon, pageStatus } = this.props;
    const urlGet = window.location.href;
    const activeClass = '';
    const isCollaborator = localStorage.getItem('isCollaborator') == 1;
    return (
      <>
           { pageStatus && <Cancellation handleParentStatus={this.handleParentStatus} /> }
           <div className={`${pageStatus ? 'd-none' : 'd-block'}`}>
              <AccountTabs mfa_auth={authorized?.userData?.UserRule?.mfa_auth} isCollaborator={isCollaborator}/>
              <div className="d-flex flex-column-fluid main_content subheader_content">
                <div className="container">
                  <div className="screen_wrapper pb-4">
                    <div className="tab-content" id="accounts-tab">
                      <div id="accountInfo" className={`tab-pane fade ${urlGet.includes('#connectedAccounts') ? '' :
                        activeClass == "active" ? '' : 'show active'}`}>
                        {userInfo ? <AccountInfo userInfo={userInfo} /> : <AccountSkeleton />}
                      </div>

                      <div id="productSubscriptions" className={`tab-pane fade  ${activeClass}`}>
                        {productInfo && productInfo.length > 0 ? <ProductSubscription productDetails={productInfo} authorized={authorized} widgetAddon={widgetAddon} ugcAddon={ugcAddon} handleParentStatus={this.handleParentStatus} /> : <ProductSubscriptionsSkeleton />}
                      </div>

                      <div id="connectedAccounts" className={`tab-pane fade ${urlGet.includes('#connectedAccounts') ? 'active show' :
                        null}`}>
                        <AccountHeading title={"Social Accounts"} />
                        {socialAccountsData && socialAccountsData.accountInformations ? <SocialAccount socialAccounts={socialAccountsData} authorized={authorized} /> : <SocialAccountSkeleton />}
                      </div>

                      <div id="MfaAuthenticator" className={`tab-pane fade ${urlGet.includes('#MfaAuthenticator') ? '' :
                        null}`}>
                       {authorized?.userData?.UserRule?.mfa_auth ==1 && !isCollaborator ? <MfaAuthenticator userData={authorized?.userData?.user}/>:null}
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userAccountData.accountInfo,
    productInfo: state.userAccountData.productSubscriptions,
    authorized: state.authenticated,
    socialAccountsData: state.userAccountData.socialAccounts,
    widgetAddon: state.userAccountData.widgetAddon,
    ugcAddon: state.userAccountData.ugcAddon,
    pageStatus: state.userAccountData.productCancellationStatus
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserInfo: () => dispatch(getUserInfo()),
    getProductInfo: () => dispatch(GET_PROD_SUBSCRIPTION()),
    GET_SOCIAL_ACCOUNT_DATA: (userId) => dispatch(GET_SOCIAL_ACCOUNT_DATA(userId)),
    getWidgetAddonData: () => dispatch(GET_WIDGET_ADDON_SUBSCRIPTION_DATA()),
    getUgcAddonData: () => dispatch(GET_UGC_ADDON_SUBSCRIPTION_DATA()),
    getAddAccountList: () => dispatch(SOCIAL_ACCOUNT_ADD_ACCOUNT_DATA()),
    productCancellationStatus: (status) => dispatch({ type: PRODUCT_CANCELANCELLATION_STATUS, payload: status }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
